<template>
  <div class="global-post">
    <!-- <shippers-head @shippers-empty="empty"></shippers-head> -->
    <div class="global-post_letter marTop20 marBott20">
      <div
        class="global-post_letter-item"
        v-for="(item, index) in letterData"
        :key="index"
        v-text="item.label"
        @click="letterButtom(index)"
        :class="{ clickLetter: item.click }">
      </div>
    </div>
    <div class="global-post_box">
      <shippers-box
        v-for="(item, index) in shippersData"
        v-show="item.isSupported"
        :key="index"
        :shippers-data="item"
        @shippers-close="close">
      </shippers-box>
    </div>
  </div>
</template>

<script>
// import shippersHead from 'components/shippers/shippersHead.vue'
import shippersBox from './shippersBox.vue'
export default {
  data () {
    return {
      shippersData: []
    }
  },
  props: {
    letterData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    letterData (n) {
      if (n.length) {
        this.shippersData = n[0].children
      }
    }
  },
  components: {
    // shippersHead,
    shippersBox
  },
  mounted () {
    // console.log('letterData', this.letterData)
    if (this.letterData.length) {
      this.shippersData = this.letterData[0].children
    }
  },
  methods: {
    letterButtom (index) {
      let vm = this
      this.letterData.map(function (item, t) {
        item.click = (t === index)
        if (t === index) {
          vm.shippersData = item.children
        }
      })
    },
    close () {
      this.$emit('shippers-close')
    },
    empty () {
      this.$emit('shippers-empty')
    }
  }
}
</script>

<style scoped>
  .global-post_letter {
    display: flex;
    flex-wrap: wrap;
  }
  .global-post_letter-item {
    width: 25px;
    height: 25px;
    margin-right: 2px;
    border-radius: 5px;
    cursor: pointer;
    line-height: 25px;
    text-align: center;
  }
  .global-post_letter-item:hover {
    color: #fff;
    background-color: #289EFC;
  }
  .clickLetter {
    color: #fff;
    background-color: #289EFC;
  }
  .global-post_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    max-height: 278px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shippers/globalPost.vue